const value = {
    drag: 'Перетащите или ',
    chooseFile: 'выберите файл',
    uploadRules: '{{list}}, не более {{maxSize}} MB',
    limitError: 'Файл превышает допустимый лимит',
    extensionError: 'Недопустимый формат файла',
    fileInfo: '{{ext}}, размер {{size}} MB',
  };

export default value;
